module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cm-0dcbc4f1fe098b1b8725ef1a2b98dae4.svg";